

import Style from 'ol/style/Style';
import CircleStyle from 'ol/style/Circle';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';
import Text from 'ol/style/Text';

export default {

    // --------------------------------------
    // Parameter 地圖 Style 參數
    // --------------------------------------
    font: '"Courier New",sans-serif',
    //font: '"Noto Sans TC","Noto Sans JP","Noto Sans SC","Courier New",sans-serif',

    NoData: [ 192, 192, 165 ],//[ 213, 213, 195 ],         // light grey

    color_black : [ 0, 0, 0, 0.8 ],
    color_white : [ 255, 255, 255 ],
    color_blue  : [ 59, 157, 206 ],
    color_green : [ 0, 204, 102 ],
    color_red   : [ 220, 50, 50 ],
    color_yellow: [ 255, 255, 0 ],

    deviceColor:
    {
        gateway:    [ 255, 255, 0, 1 ],
        weatherbox: [ 59, 157, 206, 1 ],
        wand:       [ 220, 50, 50, 1 ],
        extra:      [ 229, 102, 102, 1 ],
        undefined:  [ 0, 204, 102, 1 ],
    },


    // Points
    createPointStyle_Device: function (_color = this.color_red, font_size = 12)
    {
        return new Style ({
            image: new CircleStyle ({
                radius: 5,
                fill: new Fill ({
                    color: _color
                }),
                stroke: new Stroke ({
                    color: this.color_black,
                    width: 1.5
                })
            }),
            text: this.createTextStyle(font_size, 'normal', _color, this.color_black, 4.5)
        });
    },

    // Polygon
    createPolygonStyle_Farm: function (_color = this.color_green, stroke_color = this.color_black, stroke_width = 4)
    {
        return new Style ({
            stroke: new Stroke ({
                color: [ _color[0], _color[1], _color[2], 0.7 ],
                width: 2
            }),
            fill: new Fill ({
                color: [ _color[0], _color[1], _color[2], 0.05 ]
            }),
            text: new Text ({
                font: 'normal 12px ' + this.font,
                fill: new Fill ({
                    color: [ _color[0], _color[1], _color[2], 0.5 ]
                }),
                stroke: new Stroke ({
                    color: [ stroke_color[0], stroke_color[1], stroke_color[2], 0.8 ],
                    width: stroke_width
                })
                //, exceedLength: true
            })
        });
    },

    createTextStyle: function (font_size, font_weight = 'normal', font_color = this.color_white, stroke_color = this.color_black, stroke_width = 3)
    {
        return new Text ({
                font: font_weight + ' ' + font_size + 'px ' + this.font,
                fill: new Fill ({
                    color: [ font_color[0], font_color[1], font_color[2], 1 ]
                }),
                stroke: new Stroke ({
                    color: [ stroke_color[0], stroke_color[1], stroke_color[2], 0.8 ],
                    width: stroke_width
                })
                //, exceedLength: true
        });
    },


    style_mapDevice: function (type)
    {
        let _colorFill;
        
        switch (type)
        {
            case 'gateway':    _colorFill = this.deviceColor.gateway; break;
            case 'weatherbox': _colorFill = this.deviceColor.weatherbox; break;
            case 'wand':       _colorFill = this.deviceColor.wand; break;
            case 'extra':      _colorFill = this.deviceColor.extra; break;

            default:           _colorFill = this.deviceColor.undefined; break;
        }

        return this.createPointStyle_Device( _colorFill, 12 );
    },



    style_citiesLine: function ()
    {
        return new Style ({
            stroke: new Stroke ({
                width: 0.3,
                color: [ 0, 0, 0, 0.8 ]
            }),
            text: this.createTextStyle( 12 )
        });
    },





    // OSM Map Color Tips
    getColorTips_OSM: function (Type)
    {
        let theColorTips = '<div id="opl-color-guide" >' 
        + '<h5 style="text-align:center;"><strong>圖例</strong></h5>';

        if ( Type == 'MapDevices' )
        {
            theColorTips = theColorTips
            + '<div>本月降雨量與近十年平均值比較</div><br>'
            + '<div><div class="opl-colorblock" style="background-color:rgb(' + rainRange_High + ');"></div><div class="opl-colorinfo"> 降雨偏多 (高於歷年平均50%)</div></div>'
            + '<div><div class="opl-colorblock" style="background-color:rgb(' + rainRange_Normal + ');"></div><div class="opl-colorinfo"> 降雨正常</div></div>'
            + '<div><div class="opl-colorblock" style="background-color:rgb(' + rainRange_Low + ');"></div><div class="opl-colorinfo"> 降雨偏少 (低於歷年平均50%)</div></div>'
            + '<br></div>';
        }
        
        return new ol.Attribution({
            html: theColorTips
        });
    },

}